/* this file is transformed by vux-loader */
/* eslint-disable */
import _defineProperty from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
var prefixCls = 'shy__loading-bar';
export default {
  props: {
    percent: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: 'success'
    },
    isShow: {
      type: Boolean,
      required: true
    },
    color: {
      type: String
    },
    failedColor: {
      type: String
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    styles: function styles() {
      var style = {
        width: "".concat(this.percent, "%")
      };

      if (this.status === 'success' && this.color && this.color !== 'success' && this.color !== 'error') {
        style.backgroundColor = this.color;
      }

      if (this.status === 'error' && this.failedColor && this.failedColor !== 'success' && this.failedColor !== 'error') {
        style.backgroundColor = this.failedColor;
      }

      return style;
    },
    innerClasses: function innerClasses() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-inner-color-success"), this.status === 'success'), _defineProperty(_ref, "".concat(prefixCls, "-inner-color-error"), this.status === 'error'), _ref;
    }
  }
};